import logo200Image from '../assets/img/logo/logo_2.png'
import React from 'react'
import { Button, Form, FormGroup, Input, Label, Row, Col, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Typography from '../components/Typography'
import axios from 'axios'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdWarning } from 'react-icons/md'
import Avatar from '../components/Avatar'
import userPlaceholder from '../assets/img/users/profile.jpg'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { getUser, getUser_v2 } from '../utils/dropdownlist'

class PosStoreForm extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      isEdit: false,
      store_id: '',
      store_code: '',
      store_name: '',
      store_location: '',
      storeList: [],
      fullStoreList: [],
      remarks: '',
      company_id: '',
      timezone: '+8:00',
      admin_email: '',
      report_time: '22:00',
      rounding: false,
      userList: [],
      inValid: false,
      enable_ecart: 0,
      enable_silo: 0,
      store_type: 'Main',
      auto_cancel: 0,
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data.fullStoreList !== state.fullStoreList) {
      return {
        fullStoreList: props.data.fullStoreList,
      }
    }
    return null
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  storecodeHandler = event => {
    let { name, value } = event.target
    let inValid = this.SpecialChar(value)
    this.setState({
      [name]: value,
      inValid: inValid,
    })
  }

  SpecialChar(value) {
    var format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
    return format.test(value)
  }

  checkHandler = e => {
    let { name } = e.target
    console.log(this.state[name])
    this.setState({
      [name]: !this.state[name],
    })
  }

  handleSubmit = event => {
    event.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    if (this.state.inValid) {
      this.notificationSystem.addNotification({
        title: <MdWarning />,
        message: 'Special Character Not Allowed for Store Code',
        level: 'error',
        position: 'br',
        autoDismiss: 2,
        dismissible: 'click',
      })
    } else {
      if (!this.state.isEdit) {
        const data = {
          session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
          store_code: this.state.store_code,
          store_name: this.state.store_name,
          store_location: this.state.store_location,
          remarks: this.state.remarks,
          company_id: comp.CompanyID,
          timezone: this.state.timezone,
          admin_email: this.state.admin_email,
          report_time: this.state.report_time,
          rounding: this.state.rounding ? '1' : '0',
          enable_ecart: this.state.enable_ecart ? 1 : 0,
          enable_silo: this.state.enable_silo ? 1 : 0,
          store_type: this.state.store_type,
          //auto_cancel: this.state.auto_cancel,
          created_by: user.email,
        }

        axios
          .post(url + ':3001/v4/store/create', data)
          .then(response => {
            const result = response.data
            if (result.error == true) {
              this.props.closeModal(<MdClear />, result.message, 'error', false)
              return
            }
            console.log(result)
            this.AddStoreUser(result.data)

            // this.props.closeModal(
            //   <MdDone />,
            //   'New store added successfully.',
            //   'success',
            //   false,
            // );
          })
          .catch(error => {
            if (error.response) {
              alert(error.response.data.message)
            }
            // else if (error.request) {
            //   console.log(error.request);
            // }
            else {
              alert('Error', error.message)
            }
          })
      } else {
        const data = {
          session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
          store_id: this.state.store_id,
          store_code: this.state.store_code,
          store_name: this.state.store_name,
          store_location: this.state.store_location,
          remarks: this.state.remarks,
          company_id: comp.CompanyID,
          timezone: this.state.timezone,
          admin_email: this.state.admin_email,
          report_time: this.state.report_time,
          rounding: this.state.rounding ? '1' : '0',
          enable_ecart: this.state.enable_ecart ? 1 : 0,
          enable_silo: this.state.enable_silo ? 1 : 0,
          store_type: this.state.store_type,
          auto_cancel: this.state.auto_cancel,
          update_by: user.email,
        }

        axios
          .post(url + ':3001/v5/store/update', data)
          .then(response => {
            const result = response.data
            if (result.error == true) {
              this.props.closeModal(<MdClear />, result.message, 'error', false)
              return
            }
            this.props.closeModal(
              <MdDone />,
              'Store details updated successfully.',
              'success', //'error' post when return error
              false,
            )
          })
          .catch(error => {
            alert(error)
          })
      }
    }
  }

  AddStoreUser = StoreID => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_API_URL
    const data = {
      session_key: user.session_key,
      CompanyID: comp.CompanyID,
      ProfileID: user.userId,
      StoreID: [StoreID],
      Role: 'Admin',
    }

    axios
      .post(url + ':3000/v1/store/addUser', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        this.props.closeModal(
          <MdDone />,
          'Store details updated successfully.',
          'success', //'error' post when return error
          false,
        )
      })
      .catch(error => {
        alert(error)
      })
  }

  componentDidMount() {
    //getUser.call(this);
    this.getUser()
    if (this.props.data.isEdit) {
      let id = this.props.data.selectedStoreId
      const store = this.props.data

      let store_id = store.store_type
      if (store_id != 'Main' && store_id != 'Marketplace') {
        let id = this.state.fullStoreList.find(x => x.name == store.store_type)
        store_id = id.store_id
      }
      this.setState({
        store_id: id,
        store_code: store.store_code,
        store_name: store.store_name,
        store_location: store.store_location,
        remarks: store.remarks,
        admin_email: store.admin_email,
        report_time: store.report_time,
        timezone: store.timezone,
        rounding: store.rounding,
        enable_ecart: store.enable_ecart,
        enable_silo: store.enable_silo,
        store_type: store_id,
        auto_cancel: store.auto_cancel,
        isEdit: true,
      })
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  getUser() {
    getUser_v2()
      .then(result => {
        if (this._isMounted) {
          if (result.error == true && result.message != 'Success') {
            alert(result.message)
            return
          }
          this.setState({
            userList: result.data.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        <ModalHeader toggle={this.props.onToggleModal()}>Store Details</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label for="store_code">Store Code</Label>
                {this.state.inValid && <span className={'ps-indicator off'}>Special Charactor Not Allowed</span>}
                <Input type="text" name="store_code" value={this.state.store_code} onChange={this.storecodeHandler} maxLength={10} readOnly={this.state.isEdit} required />
              </FormGroup>
              <FormGroup>
                <Label for="store_name">Store Name</Label>
                <Input type="text" name="store_name" value={this.state.store_name} onChange={this.changeHandler} required />
              </FormGroup>
              <FormGroup>
                <Label for="store_location">Store Location</Label>
                <Input type="text" name="store_location" value={this.state.store_location} onChange={this.changeHandler} required />
              </FormGroup>
              <FormGroup>
                <Label for="remark">Remarks</Label>
                <Input type="text" name="remarks" value={this.state.remarks} onChange={this.changeHandler} />
              </FormGroup>
              <FormGroup>
                <Label for="timezone">Timezone</Label>
                <Input type="select" name="timezone" value={this.state.timezone} onChange={this.changeHandler} required>
                  <option value="+8:00">+8:00</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label for="admin_email">Admin Email</Label>
                <Input type="email" name="admin_email" value={this.state.admin_email} onChange={this.changeHandler} required>
                  {/* <option></option>
                  {this.state.userList &&
                    this.state.userList.map((item, index) => {
                      return (
                        <option key={index} value={item.email}>
                          {item.email}
                        </option>
                      );
                    })} */}
                </Input>
              </FormGroup>
              <FormGroup>
                <Label for="report_time">Report Time</Label>
                <Input type="time" name="report_time" value={this.state.report_time} onChange={this.changeHandler} required />
              </FormGroup>
              <FormGroup check>
                <Label>
                  <Input type="checkbox" name="rounding" checked={this.state.rounding} onChange={this.checkHandler} />
                  Rounding
                </Label>
              </FormGroup>
              <br />
              <FormGroup check>
                <Label>
                  <Input type="checkbox" name="enable_ecart" checked={this.state.enable_ecart} onChange={this.checkHandler} />
                  Enable Ecart
                </Label>
              </FormGroup>
              <br />
              <FormGroup check>
                <Label>
                  <Input type="checkbox" name="enable_silo" checked={this.state.enable_silo} onChange={this.checkHandler} />
                  Enable Silo
                </Label>
              </FormGroup>
              <br />
              <FormGroup>
                <Label>Store Type</Label>
                <Input type="select" name="store_type" value={this.state.store_type} onChange={this.changeHandler} required>
                  <option value="Main">Main</option>
                  <option value="Marketplace">Marketplace</option>
                  {this.state.fullStoreList.length > 0 &&
                    this.state.fullStoreList.map((item, index) => {
                      return (
                        <option key={index} value={item.store_id}>
                          {item.name}
                        </option>
                      )
                    })}
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>Auto Cancel Unpaid Orders</Label>
                <Input type="number" name="auto_cancel" value={this.state.auto_cancel} onChange={this.changeHandler} required>
                  {/* <option></option>
                  {this.state.userList &&
                    this.state.userList.map((item, index) => {
                      return (
                        <option key={index} value={item.email}>
                          {item.email}
                        </option>
                      );
                    })} */}
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button className="theme-button theme-button-secondary" onClick={this.props.onToggleModal()}>
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>{' '}
        </ModalFooter>
      </Form>
    )
  }
}

export const STATE_ADD = 'ADD'
export const STATE_EDIT = 'EDIT'
export default PosStoreForm
